


















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import SignMessage from './SignMessage.vue';
import VerifySignature from './VerifySignature.vue';
import HashData from './HashData.vue';
import ConvertAddress from './ConvertAddress.vue';

const currentTabs = {
  hash: 0,
  sign: 1,
  verify: 2,
  convert: 3
};

@Component({
  components: {
    SignMessage,
    VerifySignature,
    HashData,
    ConvertAddress
  }
})
export default class ToolBox extends Vue {
  private activeTab: number = 0;

  private mounted() {
    const value = this.$route.params.tab
    this.updateActiveTab(value)
  }

  @Watch('$route.params.tab')
  handleActiveTab(value: string) {
    this.updateActiveTab(value);
  }

  private updateActiveTab(value: string) {
    console.log('TAB', value);
    // @ts-ignore
    this.activeTab = currentTabs[value] || 0;
  }
}
